import React from 'react';
import { Navigate } from 'react-router-dom';
import { authService } from '../services/auth';

const Dashboard: React.FC = () => {
  const user = authService.getCurrentUser();
  const isSuperAdmin = user?.role === 'super_admin';

  // 역할에 따라 적절한 페이지로 리다이렉트
  return <Navigate to={isSuperAdmin ? '/tenants' : '/tenant-intro'} replace />;
};

export default Dashboard;